import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, RotateCcw } from 'lucide-react';
import { api } from '../services/api';
import CategoryTree from '../components/catalog/CategoryTree';

export default function CategoryTreePage() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    api.getCategories().then((result) => {
      if (active) setCategories(Array.isArray(result?.data) ? result.data : []);
    }).catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [attempt]);

  return (
    <main className="pp-container py-4" dir="rtl">
      <nav aria-label="مسیر صفحه" className="mb-2 flex items-center gap-2 text-xs text-slate-500"><Link to="/" className="hover:text-[#005bbb]">خانه</Link><ChevronLeft size={12} /><span aria-current="page">نمودار درختی محصولات</span></nav>
      <h1 className="mb-4 text-xl font-extrabold text-slate-900">نمودار درختی محصولات</h1>
      {loading ? <div role="status" className="flex min-h-80 items-center justify-center text-sm text-slate-500">در حال بارگذاری نمودار...</div> : error ? (
        <div role="alert" className="flex min-h-80 flex-col items-center justify-center gap-4 text-sm text-red-700"><p>دریافت دسته‌بندی‌ها انجام نشد.</p><button type="button" onClick={() => setAttempt((value) => value + 1)} className="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-4 py-2 text-slate-700"><RotateCcw size={16} />تلاش مجدد</button></div>
      ) : !categories.length ? <div className="flex min-h-80 items-center justify-center text-sm text-slate-500">هنوز دسته‌بندی ثبت نشده است.</div> : <CategoryTree categories={categories} />}
    </main>
  );
}
